import React from "react";
import { useState, useEffect, useRef, createContext } from "react";
import axios from "axios";
import a from "./a.png";
import ha from "./ha.png";
import gh from "./gh.png";
import lc from "./lc.png";
import ig from "./ig.png";

import { Link, useNavigate } from "react-router-dom";
import EditProfile from "./EditProfile";
import GoogleIcon from "@mui/icons-material/Google";
import * as rsb from "react-bootstrap";
import { FaInstagram, FaGithub, FaHackerrank } from "react-icons/fa";
import "./profile.css";
import Spinner from "react-bootstrap/Spinner";
import { Button, Input } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { GoogleLogin } from "react-google-login";
import { gapi } from "gapi-script";
import { makeStyles } from "@material-ui/core/styles";
import "./styles.css";
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff"
  }
}));
const Profile = () => {
  const classes = useStyles();
  // const URL = "https://sheetdb.io/api/v1/8vhxc0a2j518k";
  // const URL = "https://api.sheety.co/a4820b8044d7f7fb7003d7d8163a5a37/a2SvCommunityProgressSheet/info/"
  const URL = "https://app.sheetlabs.com/KINF/a2svinfo";
  let [loading, setLoading] = useState(false);
  let [name, setName] = useState("");
  let [email, setEmail] = useState("");
  let [telegram, setTelegram] = useState("");
  let [submission, setSubmission] = useState(false);
  let [editableID, setEditableID] = useState("");
  let [phone, setPhone] = useState("");
  let [instagram, setInstagram] = useState("");
  let [birthday, setBirthday] = useState("");
  let [city, setCity] = useState("");
  let [joined, setJoined] = useState("");
  let [shortBio, setShortBio] = useState("");
  let [expected, setExpected] = useState("");
  let [university, setUniversity] = useState("");
  let [dept, setDept] = useState("");
  let [leetcode, setLeetcode] = useState("");
  let [hackerrank, setHackerrank] = useState("");
  let [codeforce, setCodeforce] = useState("");
  let [github, setGithub] = useState("");
  let [favLang, setFavLang] = useState("");
  let [emailfilled, setEmailFilled] = useState("");
  let [input, setInput] = useState("");
  let [click, setClick] = useState(false);
  let [url, setUrl] = useState("");
  let [flag, setFlag] = useState("");
  let [object, setObject] = useState([]);
  let [data, setData] = useState({});
  let [shirtSize, setShirtSize] = useState();
  let [shirtColor, setShirtColor] = useState();
  let [visible, setVisible] = useState(false);
  let [editable, setEditable] = useState(true);
  const btnRef = useRef();
  const btn1 = useRef();
  const navigate = useNavigate();

  function functionForEdit(email) {
    navigate("/edit/" + editableID);
  }
  let [flag1, setFlag1] = useState("");
  const clientId =
    "784070338252-sbprqkgc0ku497a9skmeskdrbn52keu6.apps.googleusercontent.com";

  useEffect(() => {
    gapi.load("client:auth2", () => {
      gapi.auth2.init({ clientId: clientId });
    });
    axios.get(URL).then((response) => {
      setData(response.data);

      setLoading(true);
    });
  }, [click]);
  useEffect(() => {
    setFlag("");
  }, [input]);
  const handler = (event) => {
    setInput(event.target.value);
  };

  const handleClick = (event) => {
    event.preventDefault();

    data.map((info) => {
      if (info.Email === input) {
        setTimeout(() => {
          setFlag(info.Name);
        }, 2000);
        setName(info.Name);
        setClick(true);
        setEmail(info.Email);
        setTelegram(info.TelegramUsername);
        setPhone(info.PhoneNumber);
        setInstagram(info.Instagram);
        setBirthday(info.Birthday);
        setJoined(info.Joined);
        setShortBio(info.ShortBio);
        setExpected(info.ExpectedGraduationDate);
        setUniversity(info.University);
        setDept(info.Department);
        setLeetcode(info.Leetcode);
        setHackerrank(info.Hackerrank);
        setCodeforce(info.Codeforces);
        setGithub(info.Github);
        setFavLang(info.FavoriteLanguage);
        setShirtColor(info.ShirtColor);
        setShirtSize(info.ShirtSize);
        setEditableID(info.__id);
        console.log(info.Name);
      }
    });
  };
  const handleEditCLick = () => {
    setTimeout(() => {
      setEditable(false);
    }, 3000);
  };
  const responseGoogle = (response) => {
    setEmail(response.profileObj.email);
    setUrl(response.profileObj.imageUrl);
    setInput(response.profileObj.email);
    // if(response.profileObj.email )
    setEditable(false);
    setSubmission(true);
    setFlag1(response.profileObj.email);

    btn1.current.click();
    btnRef.current.click();

    // if(submission) {

    // }
  };

  let inputRef = "";
  const editRoute = "edit/" + editableID;
  const handleEdit = () => {};

  return (
    <div style={{ paddingTop: 30, margin: 5, color: "white" }}>
      <h3>📊 Welcome A2SV community </h3>

      <Spinner animation="border" variant="primary" />
      <h5 style={{ paddingTop: 10, fontSize: 16, fontWeight: "bold" }}>
        🛑 Enter your email address:
      </h5>

      <form>
        <Input
          type="email"
          ref={(input) => {
            // assigns a reference so we can trigger it later
            inputRef = input;
          }}
          value={input}
          onChange={handler}
          placeholder="johndeo@gmail.com"
          style={{
            marginRight: 15,
            paddingTop: 27,
            paddingRight: 40,
            color: "white",
            fontFamily: "monospace"
          }}
        />

        <Button
          ref={btn1}
          type="submit"
          className="bttn"
          variant="contained"
          color="secondary"
          onClick={handleClick}
        >
          GO 🚀
        </Button>

        <br />
        <h4 style={{ marginTop: 20 }}>OR</h4>
        <GoogleLogin
          clientId={clientId}
          render={(renderProps) => (
            <Button
              className="bttn"
              style={{ color: "white" }}
              variant="contained"
              color="primary"
              onClick={renderProps.onClick}
              disabled={renderProps.disabled}
            >
              {" "}
              <GoogleIcon />{" "}
              <span style={{ marginLeft: 10 }}>LogIn As Admin</span>
            </Button>
          )}
          buttonText="Login"
          onSuccess={responseGoogle}
          onFailure={responseGoogle}
          cookiePolicy={"single_host_origin"}
        />
      </form>
      {input === email && input ? (
        <div className="f" style={{ textAlign: "left", color: "white" }}>
          <h3
            style={{
              textAlign: "center",
              paddingTop: 10,
              marginTop: 20,
              color: "white"
            }}
          >
            A2SV community profile{" "}
          </h3>
          {!flag ? (
            <div>
              <Backdrop className={classes.backdrop} open>
                {" "}
                <CircularProgress color="inherit" />{" "}
              </Backdrop>
            </div>
          ) : (
            <>
              <div style={{ textAlign: "center" }}>
                {/* <h3 style={{ margin: 30 }}>List of Media's</h3> */}
                <a href={hackerrank}>
                  <img src={ha} style={{ width: 35, height: 34 }} />
                </a>

                <a href={leetcode}>
                  <img
                    src={lc}
                    style={{ width: 35, height: 34, marginLeft: 30 }}
                  />
                </a>

                <a href={github}>
                  <img
                    src={gh}
                    style={{ width: 35, height: 34, marginLeft: 30 }}
                  />
                </a>
                <a href={instagram}>
                  <img
                    src={ig}
                    style={{ width: 35, height: 34, marginLeft: 30 }}
                  />
                </a>
              </div>
              <div
                className="underline"
                style={{ textAlign: "center", paddingTop: 10, marginTop: 20 }}
              ></div>
              <p
                style={{
                  marginBottom: 7.5,
                  marginTop: 13,
                  color: "hsl(206, 36%, 88%)"
                }}
              >
                👤 NAME ➡️ {name}
              </p>
              <hr />
              <p
                style={{
                  marginBottom: 7.5,
                  marginTop: 13,
                  color: "hsl(206, 36%, 88%)"
                }}
              >
                📲 PHONE ➡️{" "}
                {Number(phone).toLocaleString("fullwide", {
                  useGrouping: false
                })}
              </p>
              <hr />
              <p
                style={{
                  marginBottom: 7.5,
                  marginTop: 13,
                  color: "hsl(206, 36%, 88%)"
                }}
              >
                📧 EMAIL ➡️ {email}
              </p>
              <hr />
              <p
                style={{
                  marginBottom: 7.5,
                  marginTop: 13,
                  color: "hsl(206, 36%, 88%)"
                }}
              >
                🎂 BIRTHDAY ➡️ {birthday}
              </p>
              <hr />
              <p
                style={{
                  marginBottom: 7.5,
                  marginTop: 13,
                  color: "hsl(206, 36%, 88%)"
                }}
              >
                🏫 UNIVERSITY ➡️ {university}
              </p>
              <hr />
              <p
                style={{
                  marginBottom: 7.5,
                  marginTop: 13,
                  color: "hsl(206, 36%, 88%)"
                }}
              >
                🙋🏾‍♂️ SHORT BIO ➡️ {shortBio}
              </p>
              <hr />
              <p
                style={{
                  marginBottom: 7.5,
                  marginTop: 13,
                  color: "hsl(206, 36%, 88%)"
                }}
              >
                🌇 CITY ➡️ {city}
              </p>
              <hr />
              <p
                style={{
                  marginBottom: 7.5,
                  marginTop: 13,
                  color: "hsl(206, 36%, 88%)"
                }}
              >
                💼 DEPARTMENT ➡️ {dept}
              </p>
              <hr />
              <p
                style={{
                  marginBottom: 7.5,
                  marginTop: 13,
                  color: "hsl(206, 36%, 88%)"
                }}
              >
                📆 Joined at ➡️{joined}
              </p>
              <hr />
              <p
                style={{
                  marginBottom: 7.5,
                  marginTop: 13,
                  color: "hsl(206, 36%, 88%)"
                }}
              >
                🎓 Expected Gratuation year ➡️ {expected}
              </p>
              <hr />
              <p
                style={{
                  marginBottom: 7.5,
                  marginTop: 13,
                  color: "hsl(206, 36%, 88%)"
                }}
              >
                👨‍💻 Favorite Language ➡️ {favLang}
              </p>
              <hr />
              <div
                style={{
                  marginTop: 10,
                  textAlign: "center"
                }}
              >
                {editable ? (
                  <h4 style={{ marginTop: 30 }}>
                    ❗️ You can edit your profile by logging to your email via
                    "LOGIN via Google" which you can find right below the email
                    input [For security purpose]
                  </h4>
                ) : (
                  <h4 style={{ marginTop: 30 }}>
                    ✅ You can edit your profile below👇🏽
                  </h4>
                )}

                <Button
                  disabled={editable}
                  className="btns"
                  onClick={handleEditCLick}
                  style={{ color: "white", border: "1px solid grey" }}
                >
                  <Link to={editRoute} style={{ color: "white" }}>
                    Edit Profile
                  </Link>
                </Button>
              </div>
            </>
          )}
          {/* 
          <div>

          onClick={(email)=>functionForEdit(email)}
            {visible ? (
              <Link to="/edit">
                <EditProfile emails={email} clicked={click} />
                <Button className="btns" onClick={() => setVisible(!visible)}>
                  EDiT Profile
                </Button>
              </Link>
            ) : (
              //  <EditProfile emails = {email} clicked={click} />
              <Button className="btns" onClick={() => setVisible(!visible)}>
                EDiT Profile
              </Button>
            )}
          </div> */}
        </div>
      ) : (
        <>
          <div style={{ textAlign: "center", paddingTop: 10, marginTop: 20 }}>
            No entry | check your email
          </div>
        </>
      )}
    </div>
  );
};
export default Profile;
